import "bootstrap/dist/css/bootstrap.css";
import "./styles/base.css";
import "@fortawesome/fontawesome";
import "bootstrap";
import "core-js";

import * as React from "react";
import * as ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { AppContainer } from "react-hot-loader";
import { IntlProvider } from "react-intl-redux";
import { Provider } from "react-redux";
import * as RoutesModule from "./routes";
import { ConnectedRouter } from "react-router-redux";
import configureStore from "./stores";
import { addLocaleData } from "react-intl";
import * as en from "react-intl/locale-data/en";
import * as es from "react-intl/locale-data/es";
import * as fr from "react-intl/locale-data/fr";
import * as de from "react-intl/locale-data/de";
import * as ar from "react-intl/locale-data/ar";
import * as nl from "react-intl/locale-data/nl";

// tslint:disable-next-line:no-var-requires
const enMessages = require("./resources/ui-en.json");
// tslint:disable-next-line:no-var-requires
const frMessages = require("./resources/ui-fr.json");
// tslint:disable-next-line:no-var-requires
const esMessages = require("./resources/ui-es.json");
// tslint:disable-next-line:no-var-requires
const deMessages = require("./resources/ui-de.json");
// tslint:disable-next-line:no-var-requires
const arMessages = require("./resources/ui-ar.json");
// tslint:disable-next-line:no-var-requires
const nlMessages = require("./resources/ui-nl.json");

let messages = enMessages;
let initialLocale: string = window.navigator.language;
initialLocale = initialLocale.split("-")[0];
let isLtr = true;

switch (initialLocale) {
    case "fr":
        messages = frMessages;
        break;
    case "es":
        messages = esMessages;
        break;
    case "de":
        messages = deMessages;
        break;
    case "nl":
        messages = nlMessages;
        break;
    case "ar":
        messages = arMessages;
        isLtr = false;
        break;
    default:
        initialLocale = "en";
        break;
}

addLocaleData(en);
addLocaleData(fr);
addLocaleData(es);
addLocaleData(de);
addLocaleData(ar);
addLocaleData(nl);

let routes = RoutesModule.routes;

async function renderApp() {
    const res = await fetch("/clientSettings.json");
    const clientSettings = await res.json();
    const cleanedMessages = JSON.stringify(messages).replace(/~TBT~/g, "").replace(/~DNT~/g, "");
    const jsonMessages = JSON.parse(cleanedMessages);

    const initialState = {
        intl: {
            locale: initialLocale,
            messages: jsonMessages,
            isLtr
        },
        clientSettings
    };
    // Create browser history to use in the Redux store
    const history = createBrowserHistory();

    // Get the application-wide store instance, prepopulating with state from the server where available.
    // const initialState = Object.assign((window as any).initialReduxState as ApplicationState, intlState);
    const store = configureStore(history, initialState);

    // This code starts up the React app when it runs in a browser. It sets up the routing configuration
    // and injects the app into a DOM element.
    ReactDOM.render(
        <AppContainer>
            <Provider store={store}>
                <IntlProvider>
                    <ConnectedRouter history={history} children={routes} />
                </IntlProvider>
            </Provider>
        </AppContainer>,
        document.getElementById("react-app")
    );
    if (initialLocale === "ar" || initialLocale === "he") {
        const body = document.getElementsByTagName("BODY")[0];
        body.setAttribute("dir", "rtl");
    }
}

function main() {
    try {
        renderApp();
    } catch (err) {
        throw err;
        // TODO: render an error page here.
    } finally {
        // To avoid getting stuck on the splash screen on loading exception.
        setTimeout(() => {
                document.getElementById("splash").className += " fade d-none";
                setTimeout(() => {
                        document.getElementById("splash").style.zIndex = "-1";
                    },
                    500);
            },
            500);
    }
// Allow Hot Module Replacement
    if ((module as any).hot) {
        (module as any).hot.accept("./routes",
            () => {
                routes = (require("./routes") as any).routes;
                renderApp();
            });
    }
}

main();
